export enum PathRoute {
  SANDBOX = '/sandbox',
  HOME = '/',
  LOGIN = '/login/:expired?',
  SIGNUP = '/signup',
  RESET_PASSWORD = '/reset-password',
  PAYMENTS_TOKENS = '/payments-tokens',
  SECURITIES_TOKENS = '/securities-tokens',
  SOROBAN_SMART_CONTRACTS = '/soroban-smart-contracts',
  BLOCKCHAIN_EXPLORER = '/blockchain-explorer',
  SETTINGS = '/settings/team-members',
  PERMISSIONS = '/settings/permissions',
  ROLES_MANAGE = '/settings/roles_manage',
  PROFILE = '/profile',
  FORGE_ASSET = '/forge-asset',
  ASSET_HOME = '/asset-management/home',
  MINT_ASSET = '/asset-management/mint',
  BURN_ASSET = '/asset-management/burn',
  DISTRIBUTE_ASSET = '/asset-management/distribute',
  AUTHORIZE_ACCOUNT = '/asset-management/authorize',
  CLAWBACK_ASSET = '/asset-management/clawback',
  FREEZE_ACCOUNT = '/asset-management/freeze',
  PUBLISH_INFORMATION = '/asset-management/publish-information',
  VAULTS = '/vaults',
  VAULT_CREATE = '/vault-create',
  VAULT_DETAIL = '/vault-detail',
  CONTRACT_DETAIL = '/contract-detail',
  CONTRACT_CREATE = '/new-certificate-of-deposit',
  TOKEN_MANAGEMENT = '/token-management',
  DASHBOARDS = '/dashboards',
  TOML_FILE = '/.well-known/stellar.toml',
  COST_CENTER = '/cost-center',
}
